import { contents } from '@console/reducers/searchResult/contents';
import { combineReducers } from 'redux';

export const searchResult = combineReducers({
  contents
});
